import { PrimeNGModule } from './primeng.module'
import { NgModule } from '@angular/core'
import { CommonModule, DatePipe } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { PhoneFormatPipe } from '../pipes/phone.pipe'
import { DateFormatPipe } from '../pipes/date.pipe'
import { SpOverlayModule } from '@sp-common/saraplus-ngx-common'
import { SafePipe } from '../pipes/safe.pipe'

@NgModule({
  declarations:
    [
      PhoneFormatPipe,
      DateFormatPipe,
      SafePipe
    ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeNGModule,
    SpOverlayModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PrimeNGModule,
    PhoneFormatPipe,
    DateFormatPipe,
    SafePipe,
    SpOverlayModule
  ],
  providers: [
    DatePipe
  ],
})
export class AppBaseModule { }
